import { ArticleModel } from './article.model';
import { BaseModel } from './base.model';
import { CartModel } from './cart.model';

export class CartItemModel extends BaseModel {
  quantity: number;
  isSample: boolean;

  unitPrice: number;
  unitTax: number;

  cartId: number | null;
  articleId: number | null;

  // Relations
  cart: CartModel | null;
  /**
   * ⚠️ PRICING ALERT — if the cart page starts displaying a price, DO NOT use
   * `unitPrice` or `article.salePrice` directly. Use `article.defaultRetailPrice`, which the
   * API resolves per the customer company's type/categories (DTX-group / customer
   * category tiers). Reading a raw sale price here would show a price that ignores
   * the customer-specific adjustment and mismatch what's actually charged.
   */
  article: ArticleModel | null;

  constructor(obj?: any) {
    super(obj);
    this.quantity = obj?.quantity ?? 1;
    this.isSample = obj?.isSample ?? false;

    this.unitPrice = obj?.unitPrice ?? 0;
    this.unitTax = obj?.unitTax ?? 0;

    this.cartId = obj?.cartId ?? null;
    this.articleId = obj?.articleId ?? null;

    // Relations
    this.cart = obj?.cart ? new CartModel(obj.cart) : null;
    this.article = obj?.article ? new ArticleModel(obj.article) : null;
  }
}
